module.exports = __webpack_public_path__ + "static/img/y36.29cb310.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y36.jpg
// module id = Ba6o
// module chunks = 1